module.exports = __webpack_public_path__ + "assets/images/snapp-logo.png";